// Central place for Homevia business details.
// Fill these in once real details are provided — every page reads from here.
export const SITE = {
  name: "Homevia Transitional Care",
  short: "Homevia",
  tagline: "Transitional care, centered on home.",
  phone: "(774) 386-6974",
  phoneHref: "tel:+17743866974",
  email: "Info@homeviatransitionalcare.org",
  address: "5250 Brownway Street, Houston, TX 77056",
  hours: "9:00 AM – 5:00 PM",
  serviceArea: "",
};

export const IMAGES = {
  heroHands: "/assets/hero-care.jpg",
  homeCare:
    "https://images.pexels.com/photos/7345474/pexels-photo-7345474.jpeg?auto=compress&cs=tinysrgb&w=1400",
  family: "/assets/family-warm.jpg",
  professionals:
    "https://images.pexels.com/photos/6129657/pexels-photo-6129657.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const VALUES = [
  {
    title: "Compassion",
    text: "We lead with warmth. Every plan begins by listening to the person, not the paperwork.",
  },
  {
    title: "Clarity",
    text: "No jargon, no guessing. Families know what happens next, and why.",
  },
  {
    title: "Coordination",
    text: "Hospital, home, and family stay on the same page — because we keep them there.",
  },
  {
    title: "Respect",
    text: "Care is built around each person's routines, preferences, and dignity.",
  },
];

export const FOCUS_AREAS = [
  {
    num: "01",
    title: "Care Transitions",
    text: "Support for the move from hospital or facility back to home — planned, not rushed.",
  },
  {
    num: "02",
    title: "Care Coordination",
    text: "Keeping physicians, discharge teams, and families aligned around one plan.",
  },
  {
    num: "03",
    title: "Support at Home",
    text: "Practical, day-to-day support that helps recovery continue where people feel best.",
  },
  {
    num: "04",
    title: "Family Guidance",
    text: "Helping families understand what to expect and how to help, every step of the way.",
  },
];
